export const toDateInputValue = (value?: string) => value ? value.split('T')[0] : '';

export const toDateTimeLocal = (iso?: string | null) => {
    if (!iso) return '';
    const date = new Date(iso);

    const pad = (n: number) => String(n).padStart(2, '0');

    // Use UTC methods to prevent local timezone shift
    const year = date.getUTCFullYear();
    const month = pad(date.getUTCMonth() + 1);
    const day = pad(date.getUTCDate());
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const toISOStringLocal = (dateStr?: string | null) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return date.toISOString();
};

export const localToUTC = (dateStr: string) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);

    // Get the UTC time equivalent of the local time
    const utcYear = date.getFullYear();
    const utcMonth = date.getMonth();
    const utcDay = date.getDate();
    const utcHour = date.getHours() - 8; // PH is UTC+8
    const utcMinute = date.getMinutes();
    const utcSecond = date.getSeconds();

    const utcDate = new Date(Date.UTC(utcYear, utcMonth, utcDay, utcHour, utcMinute, utcSecond));
    return utcDate.toISOString();
}

export const localToUTCISOString = (localDateStr: string) => {
    if (!localDateStr) return '';

    const localDate = new Date(localDateStr);

    return localDate.toISOString();
}

export const isoUTCToLocal = (isoStr: string) => {
    if (!isoStr) return '';

    const date = new Date(isoStr); // ISO string parsed as UTC
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}